import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const DisplayPage = lazy(() => import('./pages/display'));
const IndexPage = lazy(() => import('./pages/index'));

export default {
    path: '/logs',
    title: 'Zapisnici',
    Component: IndexPage,
    children: [{
        path: ':logFile',
        Component: DisplayPage,
    }],
} satisfies RouteObject;
